<template>
    <div class="shelf-wrap" :class="[shelf.active ? 'active' : '', !shelf.animate ? 'no-anim' : '']">
        <div class="shelf-body">
            <component onUpdateCount="onUpdateCount" v-if="shelf.active" :is="currentView" keep-alive></component>
        </div>
        <!--
        <transition name="fade-down-up">
            <div class="shelf-cart-info">
                <div class="cart-info-line">
                    <i class="fas fa-clipboard-list"></i>
                    <span class="label">Total Items:</span>
                    <span>
                        <count-up
                        :startVal="0"
                        :endVal="totalItemsInCart"
                        :decimals="0"
                        :duration="2"
                        :options="countOptions"></count-up>
                    </span>
                </div>
            </div>
        </transition>
        -->
        <div class="shelf-toggle"
                @click="toggleShelf" 
                :title="!shelf.active ? 'Open List' : 'Close List'">
            <div class="toggle-content">
                <div class="total font-small">Total items: <span style="color:#aadcff">{{cart.items.length}}</span></div>
                <div class="arrow"></div>
            </div>
            <!-- <i class="fas fa-cart-arrow-down"></i> -->
        </div>
    </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import CountUp from 'vue-countup-v2';
import { countOptions } from '@/utils';
import Cart from '@/ui/components/Cart.vue'
export default {
	data() {
		return {
            countOptions,
            active:true,
            currentView: 'cart'
		}
	},
    components: {
        Cart,
        CountUp
    },
    methods: {
        ...mapActions([
            'toggleShelf'
        ]),
        onUpdateCount()
        {
            alert("update the count title");
            this.$forceUpdate();
        }            
    },
    computed: {
        ...mapState([
            'shelf','cart'
        ]),
        ...mapGetters([
            'totalItemsInCart',
            'totalPriceInCart'
        ])
    }
}

</script>

<style>
	/* Portrait ipad*/
	@media only screen 
	and (min-width: 800px) 
	and (max-width: 1025px) 
	and (orientation: portrait) 
	{
        .shelf-wrap
        {
            left: 55px !important;
            width: calc(100vw - 110px) !important;
            min-width: 500px !important;
        }

	}
</style>


<style lang="stylus">
@import '~settings'
@import '~rupture'
.shelf-wrap
    min-width 768px
    position fixed
    top 0px
    left 55px
    height 47vh
    min-height 380px
    max-height 380px
    transform translateY(-100%)
    width: calc(100% - 110px);
    transition transform 0.3s 0.01s ease-out
    z-index 2000
    +below(815px)
        height 60vh
        min-height 60vh
        max-height 60vh

.shelf-wrap
	+below(815px)
        min-width 100vw
        width 100vw
        min-width 100vw
        left 0px        
.shelf-body
    position absolute
    top 0
    width 100%
    height 47vh
    min-height 380px
    max-height 380px
    background #1178be
    border-bottom-left-radius 15px
    +below(815px)
        height 60vh
        min-height 60vh
        max-height 60vh
.shelf-cart-info
    position absolute
    top 93%
    left 50%
    transform translate(-49%, 0)
    padding 50px 1vw 15px
    background rgba(#121212, 0.5)
    border 1px solid rgba(#fff, 0.2)
    text-align left
    display flex
    min-width 420px
    justify-content space-between
    z-index -1
    .cart-info-line
        display inline-block
        font-size responsive 12px 14px
        &:nth-child(2)
            margin-left 15px
        .label
            color rgba(#fff, 0.6)
            margin 0 10px 0 5px
        i
            color rgba(blue, 0.9)
            min-width 20px
            text-align center
        span
            color #fff

.shelf-toggle
    cursor pointer
    position absolute false false
    right 0px
    bottom -64px
    //transform translateX(-50%)
    //background url('assets/shelf-toggler2.png') no-repeat 0 0
    background-color #1178be
    width 170px
    //border solid 2px red
    height 64px
    border-radius 0px 0px 15px 15px
    transition bottom 200ms ease-out
    //z-index -1
    z-index 1000
    &:before
        content ""
        position absolute
        top 0px
        left -25px
        height 50px
        width 25px
        border-top-right-radius 15px
        background none
        box-shadow 0 -25px 0 0 #1178be

    +below(815px)
        right: 20px;
        bottom: -50px;
        width: 120px;
        height: 50px;
        text-align: center;        
    i
        self-center()
        top 30%
        color rgba(blue, 0.8)
        transform translate(-50%,-50%) scale(1,1)
        font-size 1.3vmax
        transition transform 0.3s ease-out

    .toggle-content
        position absolute
        top calc(50% + 1px)
        transform translateY(-50%)
        width 100%
        padding 0px 30px
        left 0px
        +above(2400px)
            padding 0px 20px
        +below(815px)
            padding 0px 20px
        .total
            //font-size 13px
            font-weight 500
            color #fff
            //transform translateX(-15px)
            span
                font-weight 500                
        .arrow
            width 12px
            height 12px            
            border 2px solid rgba(blue,0.9)
            position absolute
            right 100%
            top 5px
            right 22px
            //top 50%
            //left 50%
            transform translate(-50%, -50%) rotate(45deg)
            border-top 0
            border-left 0
            transition transform 400ms ease
            +above(2400px)
                display none
            +below(815px)
                display none
            /.no-anim .arrow
                transition none !important
            /.active .arrow
                transition transform 400ms ease
                transform translate(-50%, -30%) rotate(-495deg) !important
            // /.active i
            //     transition transform 400ms ease
            //     transform translate(-50%, -30%) rotate(-495deg) !important
&.active
    transform translateY(0)
    transition transform 1s cubic-bezier(.51,-0.01,.49,1)
&.no-anim
    transition none
</style>